/**
 * Box 2: six scorecards (spec §3.3). Δ% carries ▲/▼ and the D1 tone (spend
 * grey, CTR up green, CPC / CPM up red); a small sample is faded with "n<500".
 * data-value / data-delta hold the raw numbers for the live check.
 *
 * @module components/overview/ScorecardRow
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TONE_CLASS } from '@/services/looker/lookerDelta';
import { fmtDelta, fmtScore, scoreLabel } from '@/services/overview/overviewFormat';
import type { Scorecard } from '@/services/overview/scorecards';

export const ScorecardRow: React.FC<{ cards: Scorecard[]; currency: string | null }> = ({ cards, currency }) => {
  const { t } = useTranslation();
  return (
    <dl className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
      {cards.map((c) => (
        <div key={c.metric} data-metric={c.metric} className="min-w-0 rounded-xl border border-neutral-200 bg-white p-3">
          <dt className="text-xs font-medium text-neutral-700">{scoreLabel(c.metric, t)}</dt>
          <dd className={`mt-1 break-words text-xl font-semibold tabular-nums ${c.lowSample ? 'italic text-neutral-700' : 'text-ink-950'}`}>
            <span data-value={c.value === null ? '' : String(c.value)}>{fmtScore(c.metric, c.value, currency)}</span>
            {c.lowSample && <span className="ml-1 text-xs font-normal">{t('overview.lowSample')}</span>}
          </dd>
          <dd data-delta={c.delta === null ? '' : String(c.delta)} className={`mt-1 text-xs font-semibold tabular-nums ${TONE_CLASS[c.tone]}`}>
            {fmtDelta(c.delta)}
          </dd>
        </div>
      ))}
    </dl>
  );
};
